import { get } from '../..';

const getBuildings = () => get('locations/buildings');

export default getBuildings;
